import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import omit from 'lodash/omit';
import moment from 'moment';
import update from 'immutability-helper';
import { actions as toastrActions } from 'react-redux-toastr';
import { Col, Row } from 'react-bootstrap';
import RouteInfo from '../../../components/RouteInfo';
import AssigneeInfo from '../../../components/AssigneeInfo';
import TLMSWarning from '../../../components/TLMSWarning';
import AbnormalityInfo from '../components/AbnormalityInfo';
import Reasons from '../components/Reasons';
import ManifestsInfo from '../components/ManifestsInfo';
import RecoveryActionsInfo from '../components/RecoveryActionsInfo';
import AttachmentsInfo from '../components/AttachmentsInfo';
import CommentsInfo from '../components/CommentsInfo';
import { getRunById, loadRun } from '../../runs/duck';
import {
    clearManifestsByRun,
    clearManifestsByStop,
    getIds,
    getIsFetching as getIsFetchingManifests,
    getManifestsByRun,
    getManifestsByStop,
    loadManifestsByRun,
    loadManifestsByStop,
} from '../../manifests/duck';
import {
    assignAbnormalityToMe,
    cancelAbnormality,
    clearErrorMessage,
    closeAbnormality,
    createAbnormality,
    editAbnormality,
    getAbnormalityAttachments,
    getAbnormalityById,
    getError,
    getErrorMessage,
    getIsFetching,
    getIsPending,
    isAbnormalityAttachmentsPending,
    loadAbnormality,
    loadAbnormalityFiles,
} from '../duck';
import {
    comparingFunction,
    makeDisplayedManifestsList,
    makeStopsList,
    mapAbnormalityManifestsToSelectedManifests,
    mapWholeSelectedManifestObject,
    addMetaDataToManifests,
    composeManifestsWithMetaData,
} from '../../../shared/utils/abnormalityHelpers';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
import Loader from '../../../components/Loader/index';
import { canEditAbnormality } from '../../../shared/security/isActionAuthorized';
import AbnormalityActionButtons from '../components/AbnormalityActionButtons';
import { ABNORMALITIES, I18N } from '../../../constants';
import DelayInfo from '../components/DelayInfo';
import { hideSeverityColumn } from '../../../shared/utils/manifest';
import { formatStopLocation } from '../../../shared/utils/run';
import {
    createAbnormalityCreationBreadcrumb,
    createAbnormalityDetailBreadcrumb,
} from '../../../shared/utils/breadcrumbs';

const toastrOptions = {
    timeOut: 0,
    icon: <i style={{ margin: 20 }} className="fa fa-spinner fa-pulse fa-2x fa-fw" />,
};

class Abnormality extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comment: '',
            formData: {},
            isReadOnly: true,
            manifests: [],
            manifestsByRun: [],
            selectedDate: moment(),
            selectedManifests: [],
            selectedReason: I18N.FORMS.SELECT_REASON,
            selectedStop: I18N.FORMS.SELECT_STOP,
            trailerIdentifier: '',
            stopId: undefined,
            stopsList: [],
            errors: {},
            modalData: {
                message: '',
                mode: '',
                showModal: false,
                title: '',
            },
            delayForm: {
                currentDelay: '',
                driverTimeLeft: '',
                driverWorkingTime: '',
                etaToEmc: '',
                kmToNextPoint: '',
            },
        };
    }

    componentWillMount() {
        if (!this.props.run) {
            this.props.loadRun(this.props.runId);
        }
        if (this.props.abnormalityType === ABNORMALITIES.DELAY) {
            this.props.loadManifestsByRun(this.props.runId);
        }
        if (this.props.abnormalityId) {
            this.isCreation = false;
            this.props.loadAbnormality(this.props.abnormalityId);
            this.props.loadAbnormalityFiles(this.props.abnormalityId);
        } else {
            this.isCreation = true;
        }
        this.canUpdate = false;

        if (canEditAbnormality(this.props.abnormalityType)) {
            this.setState(() => ({ isReadOnly: false }));
        }
    }

    componentWillUnmount() {
        this.props.clearManifestsByRun();
        this.props.clearManifestsByStop();
        this.props.clearErrorMessage();
    }

    componentDidMount() {
        //when coming from /runs
        let stops = makeStopsList(this.props.run);
        this.setState({ stopsList: stops });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.run !== nextProps.run) {
            //when refreshing page
            let stops = makeStopsList(nextProps.run);
            this.setState({ stopsList: stops });
        }

        if (this.props.isPending && nextProps.hasError) {
            this.redirectOrRemovePendingToast(false);
        } else if (this.props.isPending && !nextProps.hasError) {
            this.redirectOrRemovePendingToast(true);
        }

        if (
            !this.props.abnormality &&
            this.props.abnormalityType === ABNORMALITIES.DELAY &&
            this.props.manifestsByRun !== nextProps.manifestsByRun
        ) {
            let manifestsByRun = composeManifestsWithMetaData(nextProps.manifestsByRun);
            this.setState({
                manifestsByRun: manifestsByRun,
                selectedManifests: nextProps.manifestsByRun.map(m => m.manifest.manifestId),
            });
        } else if (
            this.props.manifestsByStop !== nextProps.manifestsByStop &&
            nextProps.manifestsByStop
        ) {
            this.setState({
                manifests: nextProps.manifestsByStop.sort(comparingFunction),
            });
            if (this.props.abnormality && this.props.abnormality.abnormalityManifests) {
                const { abnormalityManifests, recoveryActions } = this.props.abnormality;
                let displayedManifests = nextProps.manifestsByStop;
                if (recoveryActions && recoveryActions.length > 0) {
                    //if it has recovery actions, correct the list of manifests displayed
                    // FTS-1669: fix makeDisplayedManifestsList so it includes recoveryActions from the correct source (not manifest itself)
                    displayedManifests = makeDisplayedManifestsList(
                        nextProps.manifestsByStop,
                        abnormalityManifests,
                        recoveryActions
                    );
                }
                const manifestsWithPallets = addMetaDataToManifests(
                    displayedManifests,
                    abnormalityManifests
                );
                this.setState({ manifests: manifestsWithPallets });
            }

            if (this.props.abnormalityType === ABNORMALITIES.MISCOLLECTION) {
                if (this.isCreation) {
                    this.setState({
                        selectedManifests: nextProps.manifestsByStop.map(
                            man => (man.manifest ? man.manifest.manifestId : man.manifestId)
                        ),
                    });
                } else {
                    const temp = mapAbnormalityManifestsToSelectedManifests(
                        nextProps.abnormality.abnormalityManifests,
                        this.state.selectedManifests
                    );
                    this.setState({ selectedManifests: temp });
                }
            }
            if (
                this.props.abnormalityType === ABNORMALITIES.DELAY &&
                // nextProps.manifestsByRun.length > 0 //can as well use the abnormalityManifests
                nextProps.abnormality.abnormalityManifests.length > 0
            ) {
                // console.log('manifestsByRun', nextProps.manifestsByRun);
                this.setState({
                    // selectedManifests: nextProps.manifestsByRun.map(
                    selectedManifests: nextProps.abnormality.abnormalityManifests.map(
                        man => (man.manifest ? man.manifest.manifestId : man.manifestId)
                    ),
                });
            }
        }

        if (this.props.abnormality !== nextProps.abnormality && nextProps.abnormality) {
            this.isCancelled =
                nextProps.abnormality && nextProps.abnormality.abnormalityStatus === 'CANCELLED';
            this.isClosed =
                nextProps.abnormality && nextProps.abnormality.abnormalityStatus === 'CLOSED';
        }

        if (
            !this.isCreation &&
            this.props.abnormality !== nextProps.abnormality &&
            nextProps.abnormality
        ) {
            this.props.loadManifestsByStop(nextProps.abnormality.stop.stopId);

            const temp = mapAbnormalityManifestsToSelectedManifests(
                nextProps.abnormality.abnormalityManifests,
                this.state.selectedManifests
            );
            this.setState({ selectedManifests: temp });

            if (nextProps.abnormality.stop) {
                const displayedStop = formatStopLocation(nextProps.abnormality.stop);
                this.setState({
                    selectedStop: displayedStop,
                    stopId: nextProps.abnormality.stop.stopId,
                });
            }
            if (nextProps.abnormality.reason) {
                this.setState({ selectedReason: nextProps.abnormality.reason });
            }
            if (nextProps.abnormality.comment) {
                this.setState({ comment: nextProps.abnormality.comment });
            }
            if (nextProps.abnormality.trailerIdentifier) {
                this.setState({
                    trailerIdentifier: nextProps.abnormality.trailerIdentifier,
                });
            }
            if (nextProps.abnormalityType === ABNORMALITIES.DELAY) {
                const delayFields = Object.assign({}, this.state.delayForm);
                Object.keys(delayFields).forEach(f => {
                    delayFields[f] =
                        f === 'etaToEmc'
                            ? moment(nextProps.abnormality[f])
                            : nextProps.abnormality[f];
                });
                const manifestsByRun = composeManifestsWithMetaData(
                    nextProps.abnormality.abnormalityManifests //only abnormalityManifests include severity info
                );
                this.setState({
                    manifestsByRun,
                    delayForm: delayFields,
                });
            }
            //set the abnormalityDate even if it's null, otherwise it will be set to today
            this.setState({
                selectedDate: moment(nextProps.abnormality.abnormalityDate),
            });
        }
    }

    // -------------------- form changes handling -------------------- //

    handleCheckSelect = (row, isSelected) => {
        if (this.props.hasError) this.props.clearErrorMessage();
        this.canUpdate = !this.isCancelled && !this.isClosed;
        let tempSelectedManifests = this.state.selectedManifests;
        let tempManifests = this.state.manifests;
        if (isSelected) {
            const index = tempSelectedManifests.indexOf(row.manifestId);
            if (index === -1) {
                //if it's not already there
                tempSelectedManifests.push(row.manifestId);
            }
            if (this.state.errors.manifests) {
                let tempVal = this.state.errors;
                delete tempVal.manifests;
                this.setState({ errors: tempVal });
            }
        } else {
            //if un-check
            const index = tempSelectedManifests.indexOf(row.manifestId);
            if (index > -1) {
                tempSelectedManifests.splice(index, 1);
            }

            //remove the totalPallets field from that manifest from the state
            forEach(tempManifests, t => {
                if (t.manifestId === row.manifestId) {
                    delete t.totalPallets;
                }
            });
        }
        if (this.state.errors.pallets) {
            let tempVal = this.state.errors;
            delete tempVal.pallets;
            this.setState({ errors: tempVal });
        }

        this.setState({
            selectedManifests: tempSelectedManifests,
            manifests: tempManifests,
        });
    };

    handleCheckSelectAll = (isSelected, rows) => {
        if (this.props.hasError) this.props.clearErrorMessage();
        this.canUpdate = !this.isCancelled && !this.isClosed;
        let tempSelectedManifests = this.state.selectedManifests;
        let tempManifests = this.state.manifests;
        if (isSelected) {
            //if all are selected
            forEach(rows, row => {
                const index = tempSelectedManifests.indexOf(row.manifestId);
                if (index === -1) {
                    tempSelectedManifests.push(row.manifestId);
                }
            });
        } else {
            tempSelectedManifests = [];
            //remove the totalPallets field from all the manifests from the state
            forEach(tempManifests, t => {
                delete t.totalPallets;
            });
        }

        if (this.state.errors.manifests) {
            let tempVal = this.state.errors;
            delete tempVal.manifests;
            this.setState({ errors: tempVal });
        }

        if (this.state.errors.pallets) {
            let tempVal = this.state.errors;
            delete tempVal.pallets;
            this.setState({ errors: tempVal });
        }
        this.setState({ selectedManifests: tempSelectedManifests });
    };

    handleDateChange = name => momentDate => {
        if (this.props.hasError) this.props.clearErrorMessage();
        this.canUpdate = !this.isCancelled && !this.isClosed;
        let temp = this.state.errors;
        delete temp[name];
        if (!moment(momentDate, 'DD-MM-YYYY HH:mm').isValid()) {
            temp[name] = 'Please insert a valid date with format: DD-MM-YYYY HH:mm';
        }
        this.setState({
            [name]: moment(momentDate, 'DD-MM-YYYY HH:mm'),
            errors: temp,
        });
    };

    handleDelayInfoDateChange = name => momentDate => {
        if (this.props.hasError) this.props.clearErrorMessage();
        this.canUpdate = !this.isCancelled && !this.isClosed;
        let temp = this.state.errors;
        delete temp[name];
        if (!moment(momentDate, 'DD-MM-YYYY HH:mm').isValid()) {
            temp[name] = 'Please insert a valid date with format: DD-MM-YYYY HH:mm';
        }
        this.setState({
            delayForm: update(this.state.delayForm, {
                [name]: { $set: moment(momentDate, 'DD-MM-YYYY HH:mm') },
                errors: { $set: temp },
            }),
        });
    };

    handleResetDate = () => {
        if (this.props.hasError) this.props.clearErrorMessage();
        let temp = this.state.errors;
        delete temp.date;
        this.setState({
            errors: temp,
            selectedDate: moment(),
        });
    };

    handleStopChange = stopId => {
        if (this.props.hasError) this.props.clearErrorMessage();
        this.canUpdate = !this.isCancelled && !this.isClosed;
        let temp = this.state.errors;
        delete temp.stop;

        const foundStop = find(this.state.stopsList, stop => stop.stopId === stopId);

        if (foundStop) {
            const displayedStop = formatStopLocation(foundStop);

            if (this.props.abnormalityType !== ABNORMALITIES.DELAY) {
                this.props.loadManifestsByStop(foundStop.stopId);
                this.setState({
                    selectedStop: displayedStop,
                    stopId: stopId,
                    selectedManifests: [],
                    errors: temp,
                });
            } else {
                const displayedStop = formatStopLocation(foundStop);
                this.setState({
                    selectedStop: displayedStop,
                    stopId: stopId,
                    errors: temp,
                });
            }
        }
    };

    handleDelayInfoTimeChange = name => value => {
        this.canUpdate = !this.isCancelled && !this.isClosed;
        const errors = omit(this.state.errors, [name]);
        this.setState({
            delayForm: update(this.state.delayForm, {
                [name]: { $set: value },
            }),
            errors,
        });
    };

    handleDelayInfoChange = e => {
        this.canUpdate = !this.isCancelled && !this.isClosed;
        const errors = omit(this.state.errors, [e.target.name]);
        this.setState({
            delayForm: update(this.state.delayForm, {
                [e.target.name]: { $set: e.target.value },
            }),
            errors,
        });
    };

    handleTrailerIdentifierChange = e => {
        if (this.props.hasError) this.props.clearErrorMessage();
        this.canUpdate = !this.isCancelled && !this.isClosed;
        this.setState({ trailerIdentifier: e.currentTarget.value });
    };

    handleReasonChange = reason => {
        if (this.props.hasError) this.props.clearErrorMessage();
        this.canUpdate = !this.isCancelled && !this.isClosed;
        let temp = this.state.errors;
        delete temp.reason;
        this.setState({ selectedReason: reason, errors: temp });
    };

    handleCommentChange = e => {
        if (this.props.hasError) this.props.clearErrorMessage();
        this.canUpdate = !this.isCancelled && !this.isClosed;
        this.setState({ comment: e.currentTarget.value });
    };

    handleCellEdit = (row, cellName, cellValue) => {
        if (this.props.hasError) this.props.clearErrorMessage();
        const { manifests } = this.state;
        let rowIdx = undefined;
        const targetRow = find(manifests, (man, i) => {
            if (man.manifestId === row.manifestId) {
                rowIdx = i;
                return true;
            }
            return false;
        });
        if (targetRow) {
            if (
                !isNaN(parseInt(cellValue, 10)) ||
                (this.props.abnormalityType === 'MISCOLLECTION' && cellValue === '')
            ) {
                targetRow[cellName] = cellValue !== '' ? parseInt(cellValue, 10) : '';
                manifests[rowIdx] = targetRow;
                this.setState({ manifests });
                this.canUpdate = !this.isCancelled && !this.isClosed;
            }
        }
    };

    // -------------------- form changes handling -------------------- //

    // -------------------- confirmation modal -------------------- //

    handleCreateAbnormalityModal = () => {
        this.setState({
            modalData: {
                showModal: true,
                title: 'Create abnormality',
                message: 'Are you sure you want to create this abnormality?',
                mode: 'createAbnormality',
            },
        });
    };

    handleUpdateAbnormalityModal = () => {
        this.setState({
            modalData: {
                showModal: true,
                title: 'Update abnormality',
                message: 'Are you sure you want to update this abnormality with these changes?',
                mode: 'updateAbnormality',
            },
        });
    };

    handleCancelAbnormalityModal = () => {
        this.setState({
            modalData: {
                showModal: true,
                title: 'Cancel abnormality',
                message: 'Are you sure you want to cancel this abnormality?',
                mode: 'cancelAbnormality',
            },
        });
    };

    handleCloseAbnormalityModal = () => {
        this.setState({
            modalData: {
                showModal: true,
                title: 'Close abnormality',
                message: 'Are you sure you want to close this abnormality?',
                mode: 'closeAbnormality',
            },
        });
    };

    handleCloseModal = () => {
        this.setState({
            modalData: {
                showModal: false,
                title: '',
                message: '',
                mode: '',
            },
            formData: {},
        });
    };

    handleConfirmModal = mode => {
        switch (mode) {
            case 'cancelAbnormality':
                this.props.cancelAbnormality({
                    abnormalityId: this.props.abnormalityId,
                });
                this.handleCloseModal();
                window.setTimeout(this.redirect, 1500);
                return;
            case 'closeAbnormality':
                this.props.closeAbnormality({
                    abnormalityId: this.props.abnormalityId,
                });
                this.handleCloseModal();
                window.setTimeout(this.redirect, 1500);
                return;
            case 'updateAbnormality':
                this.props.editAbnormality(this.props.abnormalityType, this.state.formData);
                this.handleCloseModal();
                this.props.toastr.add({
                    id: 'pendingToast',
                    type: 'info',
                    position: 'top-right',
                    title: 'Updating abnormality...',
                    attention: true,
                    options: toastrOptions,
                });
                return;
            case 'createAbnormality':
                this.props.createAbnormality(this.props.abnormalityType, this.state.formData);
                this.handleCloseModal();
                // NOTE:
                // We need the response of /createAbnormality to get the id of the abnormality and make it the toast's id,
                // but it takes way too long to get this response.
                // Show a loading toast for as long as the redirect lasts,
                // hopefully soon after the correct toastr appears
                this.props.toastr.add({
                    id: 'pendingToast',
                    type: 'info',
                    position: 'top-right',
                    title: 'Creating abnormality...',
                    attention: true,
                    options: toastrOptions,
                });
                return;
            default:
                return;
        }
    };

    redirectOrRemovePendingToast = doRedirect => {
        if (doRedirect) {
            window.setTimeout(this.redirect, 4000);
        } else {
            this.props.toastr.remove('pendingToast');
        }
    };

    redirect = () => {
        const { toastr, runId } = this.props;
        toastr.remove('pendingToast');

        this.props.router.push(`/runs/${runId}`);
    };

    // -------------------- confirmation modal -------------------- //

    // -------------------- buttons pre-confirm functionality -------------------- //

    handleCreateAbnormality = () => {
        const {
            selectedManifests,
            selectedStop,
            selectedReason,
            selectedDate,
            stopId,
            trailerIdentifier,
            comment,
            manifests,
            delayForm,
        } = this.state;

        let tempManifests = []; //selectedManifests with complete manifest data, not only ids
        forEach(selectedManifests, sel => {
            forEach(manifests, man => {
                if (man.manifestId === sel) {
                    tempManifests.push({
                        manifestId: sel,
                        palletAmount: man.totalPallets,
                    });
                }
            });
        });

        const errors = this.props.validations({
            trailerIdentifier,
            selectedDate,
            selectedStop,
            selectedReason,
            selectedManifests,
            tempManifests,
            comment,
            currentDelay: delayForm.currentDelay,
            etaToEmc: delayForm.etaToEmc,
            driverWorkingTime: delayForm.driverWorkingTime,
            driverTimeLeft: delayForm.driverTimeLeft,
        });
        this.setState({ errors });

        let formData = {
            abnormalityDate: moment(selectedDate).isValid() && selectedDate.toISOString(),
            comment: comment,
            manifestIds: tempManifests,
            reason: selectedReason,
            runId: this.props.runId,
            stopId: stopId,
            trailerIdentifier: trailerIdentifier,
        };

        if (this.props.abnormalityType === ABNORMALITIES.DELAY) {
            formData.currentDelay = delayForm.currentDelay;
            formData.driverTimeLeft = delayForm.driverTimeLeft;
            formData.driverWorkingTime = delayForm.driverWorkingTime;
            formData.etaToEmc = delayForm.etaToEmc;
            formData.kmToNextPoint = delayForm.kmToNextPoint;
        }

        if (isEmpty(errors)) {
            this.setState({ formData: formData });
            this.handleCreateAbnormalityModal('createAbnormality');
        }
    };

    handleUpdateAbnormality = () => {
        const { abnormality } = this.props;
        const {
            selectedDate,
            comment,
            selectedManifests,
            selectedReason,
            trailerIdentifier,
            manifests,
            delayForm,
            stopId,
        } = this.state;

        const filteredManifests = mapWholeSelectedManifestObject(selectedManifests, manifests);

        //check if they have the same number of pallets
        let tempManifests = [];
        let checkManifests = false;
        forEach(filteredManifests, m => {
            tempManifests.push({
                manifestId: m.manifestId,
                palletAmount: m.totalPallets,
            });
            checkManifests = true;
        });

        const errors = this.props.validations({
            comment,
            trailerIdentifier,
            selectedDate,
            selectedReason,
            selectedManifests,
            tempManifests,
            currentDelay: delayForm.currentDelay,
            etaToEmc: delayForm.etaToEmc,
            driverWorkingTime: delayForm.driverWorkingTime,
            driverTimeLeft: delayForm.driverTimeLeft,
        });
        this.setState({ errors });

        console.log('Errors', errors);

        let formData = {
            abnormalityId: this.props.abnormalityId,
        };

        let checkEdit = false;

        if (checkManifests) {
            formData.manifestIds = tempManifests;
            checkEdit = true;
        }

        if (!selectedDate.isSame(abnormality.abnormalityDate)) {
            formData.abnormalityDate = selectedDate;
            checkEdit = true;
        }

        if (comment !== abnormality.comment && abnormality.comment !== null) {
            formData.comment = comment;
            checkEdit = true;
        }
        if (selectedReason !== abnormality.reason) {
            formData.reason = selectedReason;
            checkEdit = true;
        }

        if (trailerIdentifier !== abnormality.trailerIdentifier) {
            formData.trailerIdentifier = trailerIdentifier;
            checkEdit = true;
        }

        if (stopId !== abnormality.stop.stopId) {
            formData.stopId = stopId;
            checkEdit = true;
        }

        if (this.props.abnormalityType === ABNORMALITIES.DELAY) {
            if (delayForm.currentDelay !== abnormality.currentDelay) {
                formData.currentDelay = delayForm.currentDelay;
                checkEdit = true;
            }
            if (delayForm.driverTimeLeft !== abnormality.driverTimeLeft) {
                formData.driverTimeLeft = delayForm.driverTimeLeft;
                checkEdit = true;
            }
            if (delayForm.driverWorkingTime !== abnormality.driverWorkingTime) {
                formData.driverWorkingTime = delayForm.driverWorkingTime;
                checkEdit = true;
            }
            if (delayForm.etaToEmc !== abnormality.etaToEmc) {
                formData.etaToEmc = delayForm.etaToEmc;
                checkEdit = true;
            }
            if (delayForm.kmToNextPoint !== abnormality.kmToNextPoint) {
                formData.kmToNextPoint = delayForm.kmToNextPoint;
                checkEdit = true;
            }
        }

        if (isEmpty(errors) && checkEdit) {
            this.setState({ formData: formData });
            this.handleUpdateAbnormalityModal('updateAbnormality');
        }
    };

    handleAssignAbnormalityToMe = id => {
        this.props.assignAbnormalityToMe(id);
    };

    // -------------------- buttons extra confirm functionality -------------------- //

    handleRecoveryActionClick = recoveryAction => {
        this.props.router.push(
            `/runs/${this.props.runId}/abnormality/${this.props.abnormalityType}/${
                this.props.abnormalityId
            }/recoveryAction/${recoveryAction.recoveryActionType}/${
                recoveryAction.recoveryActionId
            }`
        );
    };

    renderBreadcrumb = (abnormality, abnormalityType, run) => {
        if (isEmpty(run)) return '';
        return abnormality && abnormality.abnormalityId
            ? createAbnormalityDetailBreadcrumb({
                  run,
                  abnormality,
              })
            : createAbnormalityCreationBreadcrumb({ run, abnormalityType });
    };

    render() {
        const {
            run,
            abnormality,
            reasons,
            isFetching,
            isFetchingManifests,
            runId,
            abnormalityId,
            abnormalityType,
            abnormalityAttachments,
            isAbnormalityAttachmentsPending,
        } = this.props;
        const {
            delayForm,
            manifests,
            manifestsByRun,
            selectedDate,
            selectedStop,
            trailerIdentifier,
            selectedReason,
            comment,
            selectedManifests,
            errors,
            modalData: { showModal, title, message, mode },
            stopsList,
        } = this.state;
            const isEditable = !this.state.isReadOnly && (this.isCreation || !(this.isCancelled || this.isClosed));
            //VLGAMS-1271: Diable Abnormality Date field during modification
            const isAbnormalityDateEditable = this.isCreation;
            console.log("isAbnormalityDateEditable: "+isAbnormalityDateEditable);
            console.log("isEditable: "+isEditable);

        if (isFetching) {
            return <Loader />;
        }

    

        return (
            <div>
                {this.renderBreadcrumb(abnormality, abnormalityType, run)}

                {abnormality && abnormality.updatedByTlms && <TLMSWarning />}

                <Row>
                    <RouteInfo
                        colSize={6}
                        routeCode={run && run.routeCode}
                        runSeq={run && run.runSequence}
                        runDate={run && run.runDate}
                    />
                    <Col sm={6}>
                        <Row>
                            <AssigneeInfo
                                colSize={12}
                                assignee={abnormality && abnormality.assignee}
                                assigneeGroup={abnormality && abnormality.groupRoleAssignees}
                            />
                        </Row>
                    </Col>
                </Row>

				<Row>
                <Col sm={6}>
                <AbnormalityInfo
                    abnormalityStatus={abnormality && abnormality.abnormalityStatus}
                    abnormalityStop={abnormality && abnormality.stop.stopName}
                    abnormalityType={abnormalityType}
                    isCreation={this.isCreation}
                    isEditable={isEditable}
                    isAbnormalityDateEditable={isAbnormalityDateEditable}
                    isReadOnly={this.state.isReadOnly}
                    onDateChange={this.handleDateChange}
                    onResetDate={this.handleResetDate}
                    onStopChange={this.handleStopChange}
                    onTrailerIdentifierChange={this.handleTrailerIdentifierChange}
                    selectedDate={selectedDate}
                    selectedStop={selectedStop}
                    stops={stopsList}
                    trailerIdentifier={trailerIdentifier}
                    validations={errors}
                />

				</Col>
                
                <Col sm={6}>
					<Row>
                    <CommentsInfo 
                      comment={comment}
                      isEditable={isEditable}
                      onCommentChange={this.handleCommentChange}
                      validations={errors}
           
                      /> 
                      
                    
                    
					</Row>
                </Col>
    
				</Row>
    
	
                <Reasons
                    isCreation={this.isCreation}
                    isEditable={isEditable}
                    onReasonChange={this.handleReasonChange}
                    reasons={reasons}
                    selectedReason={selectedReason}
                    validations={errors}
                />

                {abnormalityType === ABNORMALITIES.DELAY && (
                    <DelayInfo
                        delayForm={delayForm}
                        isEditable={isEditable}
                        handleChange={this.handleDelayInfoChange}
                        handleDateChange={this.handleDelayInfoDateChange}
                        handleTimeChange={this.handleDelayInfoTimeChange}
                        validations={errors}
                    />
                )}

                <ManifestsInfo
                    abnormality={abnormality}
                    abnormalityType={abnormalityType}
                    hideSeverity={
                        !abnormality ||
                        hideSeverityColumn(abnormalityType, Object.keys(abnormality).length > 0)
                    }
                    isEditable={isEditable}
                    isFetching={isFetchingManifests}
                    isSelectable={
                        !(
                            abnormalityType === ABNORMALITIES.MISCOLLECTION ||
                            abnormalityType === ABNORMALITIES.DELAY
                        )
                    }
                    manifests={abnormalityType === ABNORMALITIES.DELAY ? manifestsByRun : manifests}
                    onCellEdit={this.handleCellEdit}
                    onCheckSelect={this.handleCheckSelect}
                    onCheckSelectAll={this.handleCheckSelectAll}
                    selectedManifests={selectedManifests}
                    url={{
                        runId: runId,
                        abnormalityId: abnormalityId,
                        abnormalityType: abnormalityType,
                    }}
                    validations={errors}
                />

                {!this.isCreation && (
                    <div>
                        <RecoveryActionsInfo
                            abnormalityId={abnormalityId}
                            abnormalityType={abnormalityType}
                            isEditable={isEditable && (!this.isClosed || !this.isCancelled)}
                            manifestsWereSelected={
                                selectedManifests && selectedManifests.length > 0
                            }
                            onRecoveryActionClick={this.handleRecoveryActionClick}
                            recoveryActions={(abnormality && abnormality.recoveryActions) || []}
                            runId={runId}
                        />
                        <AttachmentsInfo
                            abnormalityId={abnormalityId}
                            attachments={abnormalityAttachments || []}
                            isPending={isAbnormalityAttachmentsPending}
                        />
                    </div>
                )}

                

                <AbnormalityActionButtons
                    abnormality={abnormality}
                    abnormalityType={abnormalityType}
                    canUpdate={this.canUpdate}
                    handleAssignAbnormalityToMe={this.handleAssignAbnormalityToMe}
                    handleCancelAbnormalityModal={this.handleCancelAbnormalityModal}
                    handleCloseAbnormalityModal={this.handleCloseAbnormalityModal}
                    handleCreateAbnormality={this.handleCreateAbnormality}
                    handleUpdateAbnormality={this.handleUpdateAbnormality}
                    isCancelled={this.isCancelled}
                    isClosed={this.isClosed}
                    isCreation={this.isCreation}
                    runId={runId}
                />

                {showModal && (
                    <ConfirmationModal
                        message={message}
                        mode={mode}
                        onClose={this.handleCloseModal}
                        onConfirm={this.handleConfirmModal}
                        showModal={showModal}
                        title={title}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    abnormality: getAbnormalityById(state, props.abnormalityId),
    abnormalityAttachments: getAbnormalityAttachments(state, props.abnormalityId),
    errorMessage: getErrorMessage(state),
    hasError: getError(state),
    isAbnormalityAttachmentsPending: isAbnormalityAttachmentsPending(state),
    isFetching: getIsFetching(state),
    isFetchingManifests: getIsFetchingManifests(state),
    isPending: getIsPending(state),
    manifestIds: getIds(state),
    manifestsByRun: getManifestsByRun(state),
    manifestsByStop: getManifestsByStop(state),
    run: getRunById(state, props.runId),
});

const mapDispatchToProps = dispatch => ({
    assignAbnormalityToMe: bindActionCreators(assignAbnormalityToMe, dispatch),
    cancelAbnormality: bindActionCreators(cancelAbnormality, dispatch),
    clearErrorMessage: bindActionCreators(clearErrorMessage, dispatch),
    clearManifestsByStop: bindActionCreators(clearManifestsByStop, dispatch),
    clearManifestsByRun: bindActionCreators(clearManifestsByRun, dispatch),
    closeAbnormality: bindActionCreators(closeAbnormality, dispatch),
    createAbnormality: bindActionCreators(createAbnormality, dispatch),
    editAbnormality: bindActionCreators(editAbnormality, dispatch),
    loadAbnormality: bindActionCreators(loadAbnormality, dispatch),
    loadManifestsByStop: bindActionCreators(loadManifestsByStop, dispatch),
    loadManifestsByRun: bindActionCreators(loadManifestsByRun, dispatch),
    loadRun: bindActionCreators(loadRun, dispatch),
    toastr: bindActionCreators(toastrActions, dispatch),
    loadAbnormalityFiles: bindActionCreators(loadAbnormalityFiles, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Abnormality));
